!function () {
    var window = (function () { return this; })();
    var document = window.document;
    var app = window.app;
    var overwatch = window.overwatch;
    var $ = window.$;
    var _ = window._;
    var $window = $(window);

    var getScrollDistance = function () {
        //cap at 0 min so not to be weird on iphone scrolling up from top
        return Math.max($window.scrollTop(), 0);
    };

    /*
    ** @param {number} ratio - A decimal fraction that determines the rate at which the element will transform on the Y axis relative to  the scroll amount.
    ** @param {number} direction - 1 or -1 to decide whether the element should move up or down when scrolling. 1 is up. -1 is down.
    ** @param {number} throttleAmount - A millisecond value for how often the scroll event should fire, and the element should adjust. A value ** of 0 is not recommended.
    */

    $.fn.verticalParallax = function (ratio, direction, throttleAmount) {
        var isMobile = overwatch.util.mobile() || overwatch.util.touch();
        if (isMobile) {
            return;
        }

        if (typeof ratio === "undefined" || typeof ratio !== "number") {
            console.error("Error in $.fn.verticalParallax. Invalid value in parameter [ratio]. You must define a numeric rate at which you want the element to parallax, ex: .5");
        }
        var direction = (direction === 1 || direction === -1) ? direction : 1;
        var throttleAmount = (typeof throttleAmount === "number") ? throttleAmount : 5;
        var $this = this;
        var rate = ratio * direction;
        $window.on("scroll", _.throttle(function () {
            $this.css({
                "transform": "translateY(" + getScrollDistance() * rate * direction + "px)"
            });
        }, throttleAmount));
    };
    /*
    ** Give an element the attribute data-js-parallax="true" and data-parallax-ratio="{number}"
    ** and it will initialize parallax effects on it.
    ** If you want to change the direction, add data-parallax-direction="-1"
    ** If you want to change the throttling on scroll, you can pass a new millisecond value using data-parallax-throttle="{number}"
    */
    $('[data-js-parallax="true"]').each(function () {
        var $this = $(this);
        var ratio = parseFloat($this.data("parallaxRatio"));
        if (typeof ratio !== "number") {
            return;
        }
        var direction = parseInt($this.data("parallaxDirection"), 10);
        var throttleAmount = parseInt($this.data("parallaxThrottle"), 10);
        direction = !Number.isNaN(direction) ? direction : null;
        throttleAmount = !Number.isNaN(throttleAmount) ? throttleAmount : null;
        $this.verticalParallax(ratio, direction, throttleAmount);
    });
}();
